import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CandlestickBackground } from './CandlestickChart';
import { ArrowRightIcon, PlayCircleIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gray-950 pt-16" data-id="element-156">
      {/* Animated Background */}
      <CandlestickBackground data-id="element-157" />

      {/* Gradient Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-transparent to-gray-950" data-id="element-158" />
      <div className="absolute inset-0 bg-gradient-to-r from-gray-950/80 via-transparent to-gray-950/80" data-id="element-159" />

      {/* Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`,
      backgroundSize: '60px 60px'
    }} data-id="element-160" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-161">
        <div className="text-center" data-id="element-162">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full mb-8" data-id="element-163">
            <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse" data-id="element-164" />
            <span className="text-sm text-emerald-400 font-medium" data-id="element-165">
              Nowa sesja startuje 15 lutego
            </span>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-166">
            Opanuj rynki.
            <br data-id="element-167" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-amber-400" data-id="element-168">
              Zbuduj przewagę.
            </span>
          </motion.h1>

          {/* Subheadline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg sm:text-xl text-gray-400 max-w-2xl mx-auto mb-10" data-id="element-169">
            Profesjonalne szkolenia z analizy technicznej i tradingu. Naucz się
            czytać wykresy, zarządzać ryzykiem i budować powtarzalne strategie
            inwestycyjne.
          </motion.p>

          {/* CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-170">
            <Button variant="primary" size="lg" className="group" data-id="element-171">
              Rozpocznij naukę
              <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-172" />
            </Button>
            <Button variant="secondary" size="lg" data-id="element-173">
              <PlayCircleIcon className="w-5 h-5 mr-2" data-id="element-174" />
              Zobacz demo platformy
            </Button>
          </motion.div>

          {/* Stats */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl mx-auto" data-id="element-175">
            {[{
            value: '2,847+',
            label: 'Absolwentów'
          }, {
            value: '94%',
            label: 'Ukończeń'
          }, {
            value: '180h+',
            label: 'Materiałów'
          }, {
            value: '4.9',
            label: 'Ocena kursu'
          }].map((stat, index) => <div key={index} className="text-center" data-id="element-176">
                <div className="text-2xl sm:text-3xl font-bold text-white font-mono" data-id="element-177">
                  {stat.value}
                </div>
                <div className="text-sm text-gray-500 mt-1" data-id="element-178">{stat.label}</div>
              </div>)}
          </motion.div>
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-950 to-transparent" data-id="element-179" />
    </section>;
}